import React, { Component } from 'react';

// Components
import Modal from '../Modal';

class AccountCreatedModal extends Component {

  render() {
    let { account } = this.props.optionalProps;

    return (
      <Modal
        hideModal={this.props.hideModal}
        closeOnClickOutside={true}
        title="Account Created!"
      >
        <p>
          The account for {account.first_name + ' ' + account.last_name} has been successfully created.
        </p>
        <div className="modal-actions">
          <a
            className="cta"
            onClick={this.props.hideModal}
          >
            Done
          </a>
        </div>
      </Modal>
    )
  }
}

export default AccountCreatedModal;